export default __webpack_public_path__ + "static/media/piramidlaw.6f42c28a.jpg";